export const getAIActionsById = (history) => {
  const historyById = {};

  history.forEach((item) => {
    historyById[+item.id] = item.report_text || item.no_actions_description || '';
  });

  return historyById;
};
